<template>
  <div v-if="suggestions && suggestions.length > 0" class="suggestions">Essayez avec :
    <span v-for="(suggestion, index) in suggestions" :key="index">
      <router-link :to="{
        path: '/' + $searchResultManager.conceptsCatalogSlug + '/',
        query: {
          ...$route.query,
          search: suggestion
        }
      }">{{ suggestion }}</router-link>
    </span>
  </div>
</template>

<script>
export default {
  name: "ConceptSuggestions",

  props: {
    suggestions: Array,
  },
}
</script>

<style scoped lang="scss">
.suggestions {
  > :not(:last-child)::after {
    content: ", ";
  }
}
</style>